// Copyright (c) StrangeBee 2023

import { openMessage } from '.';
import copy from 'copy-to-clipboard';

export const copyToClipboard = (value: string, message?: string): void => {
    copy(value);
    message && openMessage('success', message);
};
